import React, { useState, useEffect, useCallback } from 'react';
import LoaderOverlay from './LoaderOverlay';
import { showAppAlert } from '../utils/alertService';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function CompaniesClientsList() {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [expandedCompanyId, setExpandedCompanyId] = useState(null);
  const token = localStorage.getItem('token');

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_URL}/admin/companies-clientes`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      const responseData = await response.json();
      if (response.ok) {
        setData(Array.isArray(responseData) ? responseData : []);
      } else {
        setData([]);
        showAppAlert('error', responseData.message || 'Erro ao buscar os dados.');
      }
    } catch (error) {
      setData([]);
      showAppAlert('error', 'Ocorreu um erro de rede. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const toggleCompany = (companyId) => {
    setExpandedCompanyId(expandedCompanyId === companyId ? null : companyId);
  };

  return (
    <section className="dashboard-section">
      <LoaderOverlay isLoading={isLoading} message="Carregando..." />
      <h3>Relação Lojistas X Clientes</h3>
      <div className="accordion-container">
        {data.map((company) => (
          <div key={company.id} className="accordion-item">
            <button className="accordion-header" onClick={() => toggleCompany(company.id)}>
              <span>{company.nomeFantasia}</span>
              <span>{expandedCompanyId === company.id ? '−' : '+'}</span>
            </button>
            {expandedCompanyId === company.id && (
              <div className="accordion-content">
                <div className="company-details">
                  <p><strong>Responsável:</strong> {company.nomeResponsavel}</p>
                  <p><strong>Telefone:</strong> {company.telefone}</p>
                </div>
                {company.clients && company.clients.length > 0 ? (
                  <table className="dashboard-table inner-table">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>E-mail</th>
                        <th>Saldo de Pontos</th>
                      </tr>
                    </thead>
                    <tbody>
                      {company.clients.map((client) => (
                        <tr key={client.id}>
                          <td>{client.nome}</td>
                          <td>{client.email}</td>
                          <td>{client.saldo_pontos}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : <p>Nenhum cliente associado.</p>}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default CompaniesClientsList;